import Swiper from 'swiper';

const ContactPersons = {
    init() {
        const contactPersons = document.querySelector('.js-contact-persons');
        const contactPersonsToggle = [...document.querySelectorAll('.js-contact-persons-toggle')];
        const contactPersonsMail = [...document.querySelectorAll('.js-contact-person-mail')];
        // const closeBtn = document.querySelector('.js-contact-persons-toggle.js-close-btn');

        if (contactPersons) {
            new Swiper('.js-contact-persons', {
                slidesPerView: 'auto',
                allowTouchMove: false,
                breakpoints: {
                    767: {
                        slidesPerView: 1.5,
                        allowTouchMove: true,
                    },
                    979: {
                        slidesPerView: 2.5,
                        allowTouchMove: true,
                    },
                },
            });

            contactPersonsToggle.forEach(trigger => {
                trigger.addEventListener('click', () => {
                    contactPersons.closest('.contact-persons').classList.toggle('is-active');

                    if (window.dataLayer) {
                        window.dataLayer.push({
                            event: 'contact button',
                            'event-label': window.location.href,
                        });
                    }
                });
            });

            contactPersonsMail.forEach(person => {
                person.addEventListener('click', () => {
                    if (window.dataLayer) {
                        window.dataLayer.push({
                            event: 'email contact',
                            'event-label': person.title,
                        });
                    }
                });
            });
        }
    },
};

export default ContactPersons;
